module.exports = __webpack_public_path__ + "static/media/Plane.a70f4a60.svg";